import React from "react";
import PropTypes from "prop-types";
import InfoOutline from "material-ui/svg-icons/action/info-outline";
import CheckCircle from "material-ui/svg-icons/action/check-circle";
import Warning from "material-ui/svg-icons/alert/warning";
import ErrorIcon from "material-ui/svg-icons/alert/error";

const icons = {
  success: CheckCircle,
  warning: Warning,
  error: ErrorIcon,
};

const iconColors = {
  success: "#4caf50",
  warning: "#ffc107",
  error: "#e53935",
};

const iconStyle = {
  width: 30,
  height: 30,
  verticalAlign: "middle",
  marginRight: 8,
  flexShrink: 0,
};

const InfoMessage = ({ children, variant }) => {
  const Icon = variant ? icons[variant] : InfoOutline;
  const color = variant ? iconColors[variant] : "#2362a2";

  return (
    <p
      className={`infoMessage${variant ? ` infoMessage--${variant}` : ""}`}
      style={{ display: "flex", alignItems: "center" }}
    >
      <Icon color={color} style={iconStyle} />
      <strong>{children}</strong>
    </p>
  );
};

InfoMessage.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["success", "warning", "error"]),
};

InfoMessage.defaultProps = {
  variant: null,
};

export default InfoMessage;
